var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10467_4981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.000305176L2.5 3.73649V12.5277C2.5 14.5168 3.29018 16.4245 4.6967 17.831C6.10322 19.2375 8.01088 20.0277 10 20.0277C11.9891 20.0277 13.8968 19.2375 15.3033 17.831C16.7098 16.4245 17.5 14.5168 17.5 12.5277V3.73649L10 0.000305176ZM14.2688 17.0714L10 14.9449V16.3375L13.1476 17.9055C12.1993 18.4577 11.1225 18.7506 10.0252 18.7548C8.92791 18.7589 7.84886 18.4742 6.89649 17.9292C5.94411 17.3842 5.15196 16.5981 4.59964 15.6499C4.04732 14.7018 3.75429 13.625 3.75 12.5277V4.50624L10 1.39274L16.25 4.50624V6.84999L10 3.73643V5.12887L16.25 8.24237V10.5861L10 7.47262V8.86506L16.25 11.9785V12.5277C16.2503 13.0954 16.1725 13.6606 16.0187 14.2071L10 11.2087V12.6012L15.5595 15.3707C15.2297 16.0073 14.7931 16.5826 14.2688 17.0714Z",
    fill: "#00EEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10467_4981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSecurity);
export default __webpack_public_path__ + "static/media/account-security.8bd30182067a0f3c38124a665567e653.svg";
export { ForwardRef as ReactComponent };